var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {},
    [
      _c("modal", {
        ref: "modal",
        staticClass: "modify-modal modify-modal__logout",
        attrs: {
          variant: "default",
          "no-footer": "",
          "is-alert-dialog": "",
          "aria-labelled-by": "modify-logout-modal-title",
        },
        on: { input: _vm.handleOpenModal, close: _vm.handleCloseModal },
        scopedSlots: _vm._u(
          [
            {
              key: "default",
              fn: function (ref) {
                var activate = ref.activate
                return [_vm._t("default", null, null, { activate: activate })]
              },
            },
            {
              key: "header",
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      staticClass: "title",
                      attrs: { id: "modify-logout-modal-title" },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.ModifyReservationPopupSessionTitle) +
                          "\n      "
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "body",
              fn: function (ref) {
                var deactivate = ref.deactivate
                return [
                  _c("div", { staticClass: "description" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.ModifyReservationPopupSessionSubTitle) +
                        "\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "button-wrapper" }, [
                    _c(
                      "button",
                      {
                        staticClass: "button extend-session",
                        on: {
                          click: function ($event) {
                            return _vm.extendSession(deactivate)
                          },
                          keydown: [
                            function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "space",
                                  32,
                                  $event.key,
                                  [" ", "Spacebar"]
                                )
                              ) {
                                return null
                              }
                              $event.preventDefault()
                              return _vm.extendSession(deactivate)
                            },
                            function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              $event.preventDefault()
                              return _vm.extendSession(deactivate)
                            },
                          ],
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.ModifyReservationPopupSessionCTALabel) +
                            "\n        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "button end-session",
                        on: {
                          click: function ($event) {
                            return _vm.closeSession(deactivate)
                          },
                          keydown: [
                            function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "space",
                                  32,
                                  $event.key,
                                  [" ", "Spacebar"]
                                )
                              ) {
                                return null
                              }
                              $event.preventDefault()
                              return _vm.closeSession(deactivate)
                            },
                            function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              $event.preventDefault()
                              return _vm.closeSession(deactivate)
                            },
                          ],
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.ModifyReservationPopupEndSessionCTALabel
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]),
                ]
              },
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }